import {apiFetch} from "../../api";
import {BASE_URL as u} from "../../../commonUrls";

const BASE_URL = `${u}/transaction`;
//const USER_ID = "u-c136202b-94f4-4e51-aa0b-72db0503c362";

// Expense
export async function addExpense(data){
  return apiFetch(`${BASE_URL}/addExpense`,{
    method:"POST",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify(data)
  });
}

// Income
export async function addIncome(data){
  return apiFetch(`${BASE_URL}/addIncome`,{
    method:"POST",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify(data)
  });
}

// Transfer
export async function addTransfer(data){
  return apiFetch(`${BASE_URL}/transfer`,{
    method:"POST",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify(data)
  });
}

export async function getAllTransactions(){
  const res = await apiFetch(`${BASE_URL}`);
  return res.json();
}

export async function deleteTransaction(id){
  await fetch(`${BASE_URL}/${id}`,{
    method:"DELETE"
  });
}
